"use strict";

// Shared course display values; saved records are never modified by resolution.
const PRESETS = Object.freeze({
  "editorial-parallax": Object.freeze({
    accent: "#b6c0ca", lightPanelBg: "#e4ebf1", sectionBg: "#101418", pageBg: "#101418",
    panelBg: "#1b222a", label: "Editorial Masterclass", signalLabel: "Field Notes",
  }),
  "wine-split": Object.freeze({
    accent: "#b6c0ca", lightPanelBg: "#e4ebf1", sectionBg: "#101418", pageBg: "#101418",
    panelBg: "#1b222a", label: "Split Masterclass", signalLabel: "Pressure / Response",
  }),
  "data-room": Object.freeze({
    accent: "#b6c0ca", lightPanelBg: "#e4ebf1", sectionBg: "#101418", pageBg: "#101418",
    panelBg: "#1b222a", label: "Data Room", signalLabel: "Operating Signals",
  }),
  "process-index": Object.freeze({
    accent: "#b6c0ca", lightPanelBg: "#e4ebf1", sectionBg: "#101418", pageBg: "#101418",
    panelBg: "#1b222a", label: "Process Index", signalLabel: "Step Index",
  }),
});
const PRESET_KEYS = Object.freeze(Object.keys(PRESETS));
// Display names only; keep the existing saved keys and shared public labels.
const COURSE_TEMPLATE_NAMES = Object.freeze({
  'editorial-parallax': 'Slate Editorial (Default)',
  'wine-split': 'Red & Blue Compliance',
  'data-room': 'Teal & Blue Operations',
  'process-index': 'Orange Safety & Training',
});
const isCoursePreset = value =>
  typeof value === "string" && Object.prototype.hasOwnProperty.call(PRESETS, value);
const legacyAccents = new Set(['#d4af37', '#e9c46a', '#4c8dcc', '#34d399', '#7dd3fc']);
function accentOverride(record) {
  const value = typeof record?.accentColor === 'string' ? record.accentColor.trim() : '';
  return /^#[0-9a-f]{6}$/i.test(value) && !legacyAccents.has(value.toLowerCase()) ? value : '';
}

function resolveCoursePresentation(record) {
  const key = isCoursePreset(record?.publicTheme) ? record.publicTheme : "editorial-parallax";
  const base = PRESETS[key];
  const explicitLabel = typeof record?.themeLabel === "string" ? record.themeLabel.trim() : "";
  return {
    key,
    ...base,
    accent: accentOverride(record) || base.accent,
    label: explicitLabel || base.label,
    // This is signal text only; publicTheme remains the layout authority.
    visualTemplate: String(record?.visualTemplate || "course-detail").replace(/-/g, " "),
  };
}

// Course pages and their library cards get the subject palettes. Other shared
// uses keep their approved presentation, and the default course stays unchanged.
const detailVariants = Object.freeze({
  'wine-split': Object.freeze({ accent: '#e56a78', secondaryAccent: '#6ca9ee', lightPanelBg: '#f2e9ef' }),
  'data-room': Object.freeze({ accent: '#52c3bb', secondaryAccent: '#6e9de8', lightPanelBg: '#e6f3f3' }),
  'process-index': Object.freeze({ accent: '#f3a34a', secondaryAccent: '#e3704f', lightPanelBg: '#fff1df' }),
});
function resolveCourseDetailPresentation(record) {
  const theme = resolveCoursePresentation(record);
  const variant = detailVariants[theme.key];
  return variant ? { ...theme, ...variant, accent: accentOverride(record) || variant.accent } : theme;
}

module.exports = { PRESET_KEYS, COURSE_TEMPLATE_NAMES, isCoursePreset, resolveCoursePresentation, resolveCourseDetailPresentation };
